import React from "react";
import { Container, Grid } from "@mui/material";
import VendorCard from "./VendorCard";
import ff_jewelry_1 from "./Pictures/FashionFusion/ff_jewelry_1.jpg";
import ff_jewelry_2 from "./Pictures/FashionFusion/ff_jewelry_2.jpg";
import ff_jewelry_3 from "./Pictures/FashionFusion/ff_jewelry_3.jpg";
import ff_jewelry_4 from "./Pictures/FashionFusion/ff_jewelry_4.jpg";
import ff_jewelry_5 from "./Pictures/FashionFusion/ff_jewelry_5.jpg";
import ff_jewelry_6 from "./Pictures/FashionFusion/ff_jewelry_6.jpg";
import ajc_biz_card from "./Pictures/aminaJewelryCollection/ajc_biz_card.jpg";
import ajc_jewelry_1 from "./Pictures/aminaJewelryCollection/ajc_jewelry_1.jpg";
import ajc_jewelry_2 from "./Pictures/aminaJewelryCollection/ajc_jewelry_2.jpg";
import ajc_jewelry_3 from "./Pictures/aminaJewelryCollection/ajc_jewelry_3.jpg";
import ajc_jewelry_5 from "./Pictures/aminaJewelryCollection/ajc_jewelry_5.jpg";
import sc_logo from "./Pictures/SairasCheesecake/sc_logo.jpg";
import sc_food_1 from "./Pictures/SairasCheesecake/sc_food_1.jpg";
import sc_food_2 from "./Pictures/SairasCheesecake/sc_food_2.jpg";
import sc_food_3 from "./Pictures/SairasCheesecake/sc_food_3.jpg";
import sc_intro_logo from "./Pictures/SairasCheesecake/sc_intro_logo_logo.jpg";
//import sc_price_chart from "./Pictures/SairasCheesecake/sc_price_chart.jpg";
import bc_dress_1 from "./Pictures/BasRafClothing/bc_dress_1.jpg";
import bc_dress_2 from "./Pictures/BasRafClothing/bc_dress_2.jpg";
import bc_dress_3 from "./Pictures/BasRafClothing/bc_dress_3.jpg";
import bc_dress_4 from "./Pictures/BasRafClothing/bc_dress_4.jpg";
import sj_logo from "./Pictures/ShreeLuxeJeweler/sj_logo.jpg";
import sj_jewelry_1 from "./Pictures/ShreeLuxeJeweler/sj_jewelry_1.jpg";
import sj_jewelry_2 from "./Pictures/ShreeLuxeJeweler/sj_jewelry_2.jpg";
import sj_jewelry_3 from "./Pictures/ShreeLuxeJeweler/sj_jewelry_3.jpg";
import sj_jewelry_4 from "./Pictures/ShreeLuxeJeweler/sj_jewelry_4.jpg";
import sj_jewelry_5 from "./Pictures/ShreeLuxeJeweler/sj_jewelry_5.jpg";
import sj_jewelry_6 from "./Pictures/ShreeLuxeJeweler/sj_jewelry_6.jpg";
import sj_jewelry_7 from "./Pictures/ShreeLuxeJeweler/sj_jewelry_7.jpg";
import sj_jewelry_8 from "./Pictures/ShreeLuxeJeweler/sj_jewelry_8.jpg";
import sj_jewelry_9 from "./Pictures/ShreeLuxeJeweler/sj_jewelry_9.jpg";
import sj_jewelry_10 from "./Pictures/ShreeLuxeJeweler/sj_jewelry_10.jpg";
import sj_jewelry_11 from "./Pictures/ShreeLuxeJeweler/sj_jewelry_11.jpg";
import ast_food_1 from "./Pictures/AsmieSweetTreats/ast_food_1.jpg";
import ast_food_2 from "./Pictures/AsmieSweetTreats/ast_food_2.jpg";
import ast_food_3 from "./Pictures/AsmieSweetTreats/ast_food_3.jpg";
import ast_food_4 from "./Pictures/AsmieSweetTreats/ast_food_4.jpg";
import ast_food_5 from "./Pictures/AsmieSweetTreats/ast_food_5.jpg";
import ast_food_6 from "./Pictures/AsmieSweetTreats/ast_food_6.jpg";
import ast_food_7 from "./Pictures/AsmieSweetTreats/ast_food_7.jpg";
import lc_food_1 from "./Pictures/LittleChefs/lc_food_1.jpg";
import lc_food_2 from "./Pictures/LittleChefs/lc_food_2.jpg";
import lc_food_3 from "./Pictures/LittleChefs/lc_food_3.jpg";
import lc_food_4 from "./Pictures/LittleChefs/lc_food_4.jpg";
import sk_logo from "./Pictures/SKWears/sk_logo.jpg";
import skw_jewelry_1 from "./Pictures/SKWears/skw_jewelry_1.jpg";
import skw_dress_2 from "./Pictures/SKWears/skw_dress_2.jpg";
import skw_dress_3 from "./Pictures/SKWears/skw_dress_3.jpg";
import skw_dress_4 from "./Pictures/SKWears/skw_dress_4.jpg";
import skw_dress_5 from "./Pictures/SKWears/skw_dress_5.jpg";
import skw_dress_6 from "./Pictures/SKWears/skw_dress_6.jpg";
import skw_dress_7 from "./Pictures/SKWears/skw_dress_7.jpg";
import skw_dress_8 from "./Pictures/SKWears/skw_dress_8.jpg";
import sk_wear_9 from "./Pictures/SKWears/sk_wear_9.jpg";
import sk_wear_10 from "./Pictures/SKWears/sk_wear_10.jpg";
import sk_wear_11 from "./Pictures/SKWears/sk_wear_11.jpg";
import ja_logo_new from "./Pictures/JowharaAccessories/ja_logo_new.jpg";
import ja_jewelry_1 from "./Pictures/JowharaAccessories/ja_jewelry_1.jpg";
import ja_jewelry_3 from "./Pictures/JowharaAccessories/ja_jewelry_3.jpg";
import ja_jewelry_4 from "./Pictures/JowharaAccessories/ja_jewelry_4.jpg";
import ja_jewelry_5 from "./Pictures/JowharaAccessories/ja_jewelry_5.jpg";
import ja_jewelry_7 from "./Pictures/JowharaAccessories/ja_jewelry_7.jpg";
import mc_dress_1 from "./Pictures/MahjabeenClothing/mc_dress_1.jpg";
import mc_dress_2 from "./Pictures/MahjabeenClothing/mc_dress_2.jpg";
import mc_dress_3 from "./Pictures/MahjabeenClothing/mc_dress_3.jpg";
import mc_dress_4 from "./Pictures/MahjabeenClothing/mc_dress_4.jpg";
import mc_dress_6 from "./Pictures/MahjabeenClothing/mc_dress_6.jpg";
import mc_dress_7 from "./Pictures/MahjabeenClothing/mc_dress_7.jpg";
import mc_dress_8 from "./Pictures/MahjabeenClothing/mc_dress_8.jpg";
import hj_henna_flyer from "./Pictures/HennabyJeem/hj_henna_flyer.jpg";
import hj_henna_1 from "./Pictures/HennabyJeem/hj_henna_1.jpg";
import hj_henna_2 from "./Pictures/HennabyJeem/hj_henna_2.jpg";
import hj_henna_3 from "./Pictures/HennabyJeem/hj_henna_3.jpg";
import hj_henna_4 from "./Pictures/HennabyJeem/hj_henna_4.jpg";
import sf_art_2 from "./Pictures/SabaFarukhArt/sf_art_2.jpg";
import sf_art_4 from "./Pictures/SabaFarukhArt/sf_art_4.jpg";
import sf_art_5 from "./Pictures/SabaFarukhArt/sf_art_5.jpg";
import sf_art_8 from "./Pictures/SabaFarukhArt/sf_art_8.jpg";
import sf_art_12 from "./Pictures/SabaFarukhArt/sf_art_12.jpg";
import BL_1 from "./Pictures/BasicLogos/BL_1.jpg";
import BL_2 from "./Pictures/BasicLogos/BL_2.jpg";
import BL_3 from "./Pictures/BasicLogos/BL_3.jpg";
import BL_4 from "./Pictures/BasicLogos/BL_4.jpg";
import BL_5 from "./Pictures/BasicLogos/BL_5.jpg";
import BL_6 from "./Pictures/BasicLogos/BL_6.jpg";
import BL_7 from "./Pictures/BasicLogos/BL_7.jpg";
import BL_8 from "./Pictures/BasicLogos/BL_8.jpg";
import BL_9 from "./Pictures/BasicLogos/BL_9.jpg";
import UC_Logo from "./Pictures/UmisCafe/UC_Logo.jpg";

const VendorGrid = () => {
    const vendors = [
        {
            name: "Saira's Cheesecake",
            logo: sc_logo,
            description: `I’m Saira, the baker behind Saira’s Cheesecake, I use fresh, high-quality 
            ingredients and offer classic and custom flavors for any occasion. Order local, support small, 
            and treat yourself to something sweet!`,
            images: [sc_food_1, sc_food_2, sc_food_3, sc_intro_logo],
            socials: [
                {
                    fb: 'https://www.facebook.com/profile.php?id=61582520257265',
                    ig: 'https://www.instagram.com/sairascheesecake/',
                    // wp: '' // for whatsapp
                    //et: '' // for etsy
                }
            ]
        },
        {
            name: "Fashion Fusion",
            logo: ff_jewelry_1,
            description: "Fashion Fusion is owned by two sisters Farah and Aiza. It's a symbol of love, passion, and unity. Every piece from Fashion Fusion is unique, classy and a reflection of individuality as we love to customize according to our style and color. 'When in doubt choose classy' ",
            images: [ff_jewelry_1, ff_jewelry_2, ff_jewelry_3, ff_jewelry_4, ff_jewelry_5, ff_jewelry_6],
            socials: [
                {
                    ig: 'https://www.instagram.com/fashion786fusion/',
                }
            ]
        },
        {
            name: "Amina Jewelry Collection",
            logo: ajc_biz_card,
            description: "Step into a world of sparkle at our jewelry haven! ✨ Discover timeless pieces, from elegant classics to bold statement designs, perfect for every style and occasion. Visit us at the exhibition and let your next treasure find you!",
            images: [ajc_jewelry_1, ajc_jewelry_2, ajc_jewelry_3, ajc_jewelry_5],
            socials: [
                { 
                    fb: 'https://www.facebook.com/Amina.jewlery' 
                }
            ]
        },
        {
            name: "BasRaf Clothing",
            logo: bc_dress_3,
            description: "Basraf Clothing specializes in modest women’s wear, with a focus on elegant abayas and everyday pieces designed for comfort and confidence. We also provide Hijabs and other accessories to cater to a wider audience.",
            images: [bc_dress_1, bc_dress_2, bc_dress_3, bc_dress_4],
            socials: [
                {
                    et: 'https://basrafclothing.etsy.com',
                }
            ]
        },
        {
            name: "ShreeLuxe Jewelers",
            logo: sj_logo,
            description: `Hi, my name is Gita and I'm the owner of ShreeLuxe Jewler. I specialize in high-quality imitation jewler, inclusing American diamonds, Nepali traditional
                          pieces, and temple jewlert from India and Nepal. My collection is afforadable, elegant, and perfect for weddings, parties, and everydat wear. Im excited to showcase a variety of unique designs at the Fashion Bazaar.`,
            images: [sj_jewelry_1, sj_jewelry_2, sj_jewelry_3, sj_jewelry_4, sj_jewelry_5, sj_jewelry_6, sj_jewelry_7, sj_jewelry_8, sj_jewelry_9, sj_jewelry_10, sj_jewelry_11],
            socials: [
                {
                    //vendor has a tiktok 
                    // et: '', //for etsy
                    // wp: '' // for whatsapp
                }
            ]
        },
        {
            name: "Asmie Sweet Treats",
            logo: ast_food_1,
            description: `Enjoy gourmet Dubai chocolate tarts and other flavors, Dubai chocolate brownie, finger licking Pistachio tiramisu and other sweet treats.`,
            images: [ast_food_1, ast_food_2, ast_food_3, ast_food_4, ast_food_5, ast_food_6, ast_food_7],
            socials: [
                {
                    ig: 'https://www.instagram.com/asmieschocolates/',
                }
            ]
        },
        {
            name: "Little Chefs Baking Happiness",
            logo: lc_food_2,
            description: `Specializing in handcrafted baked goods 🍰, I create cookies, cakes, cheesecakes, and a variety of freshly made desserts. Every item is prepared with care, quality ingredients, and a passion for homemade flavor ❤️.`,
            images: [lc_food_1, lc_food_2, lc_food_3, lc_food_4],
            socials: [
                {
                    et: 'https://www.etsy.com/shop/SisterStyleStudioUS',
                    ig: 'https://www.instagram.com/littlechefsbakinghappiness?igsh=MWF6Ym5sdG5yNWZ4Ng==',
                }
            ]
        },
        {
            name: "SK Wears",
            logo: sk_logo,
            description: `SK Wears offers a wide range of traditional Pakistani clothing, along with purses, shawls, and jewelry.`,
            images: [skw_jewelry_1, skw_dress_2, skw_dress_3, skw_dress_4, skw_dress_5, skw_dress_6, skw_dress_7, skw_dress_8, sk_wear_9, sk_wear_10, sk_wear_11],
            socials: [
                {
                    wp: 'https://chat.whatsapp.com/LLWIGWAJ0P8BtNfL768Xub?mode=hqrt1',
                }
            ]
        },
        {
            name: "Jowhara Accessories",
            logo: ja_logo_new,
            description: `Jowhara Accessories sells gold plated jewelry.`,
            images: [ja_jewelry_1, ja_jewelry_3, ja_jewelry_4, ja_jewelry_5, ja_jewelry_7],
            socials: [
                {
                    fb: 'https://www.facebook.com/share/17t3qVVgFi/',
                    ig: 'https://www.instagram.com/jowhara.accessories?igsh=cWM4N3RraTQzajVk',
                }
            ]
        },
        {
            name: "Mahjabeen Couture",
            logo: mc_dress_1,
            description: `Mahjabeen Couture sells traditional clothing ranging from casual to formal styles as well as accessories.`,
            images: [mc_dress_2, mc_dress_3, mc_dress_4, mc_dress_6, mc_dress_7, mc_dress_8],
            socials: [
                {
                    ig: 'https://www.instagram.com/mahjabeen_couture/',
                }
            ]
        },
        {
            name: "HennabyJeem",
            logo: hj_henna_flyer,
            description: `I'm Javeria Sadeed, the Henna Artist behind HennabyJeem 🤎✨, I create modern + traditional mehndi using high-quality, natural henna — perfect for brides, parties, & special ocasions. I am based in DFW, Texas. Open for bookings! Book your slot in Fashion Bazaar and treat yourself to something beautiful!`,
            images: [hj_henna_1, hj_henna_2, hj_henna_3, hj_henna_4],
            socials: [
                {
                    ig: 'https://www.instagram.com/hennabyjeem?igsh=MXRzMWJ2Znk2NGF3NA==',
                }
            ]
        },
        {
            name: "Saba Farrukh Art",
            logo: sf_art_12,
            description: `Saba Farrukh is a local North Texas based artist and teacher. She has been teaching youth and making art for over 25 years.`,
            images: [sf_art_2, sf_art_4, sf_art_5, sf_art_8],
            socials: [
                {
                    ig: 'https://www.instagram.com/sabafarrukhofficial/',
                }
            ]
        },
        {
            name: "AA Collection",
            logo: BL_1,
            description: `Jewelry!`,
            images: [],
            socials: [
                {
                    ig: 'https://www.instagram.com/akhtarpalina25/',
                }
            ]
        },
        {
            name: "Umi's Cafe",
            logo: UC_Logo,
            description: `Come and grab your favorite coffee at Umi’s Café, where great flavor and friendly service meet wherever you are.`,
            images: [],
            socials: [
                {
                    
                }
            ]
        },
        {
            name: "Seen Clothing",
            logo: BL_3,
            description: `Clothes!`,
            images: [],
            socials: [
                {
                    
                }
            ]
        },
        {
            name: "Zavia's",
            logo: BL_4,
            description: `Clothes!`,
            images: [],
            socials: [
                {
                    
                }
            ]
        },
        {
            name: "SAMSUN",
            logo: BL_5,
            description: `Clothes, accessories!`,
            images: [],
            socials: [
                {
                    
                }
            ]
        },
        {
            name: "Chaat Corner",
            logo: BL_2,
            description: `Food!`,
            images: [],
            socials: [
                {
                    
                }
            ]
        },
        {
            name: "AM’S ABAYA ",
            logo: BL_6,
            description: `Abayas, Clothes!`,
            images: [],
            socials: [
                {
                    
                }
            ]
        },
        {
            name: "Hum Fashions",
            logo: BL_7,
            description: `Clothes!`,
            images: [],
            socials: [
                {
                    
                }
            ]
        },
        {
            name: "Best of Kashmir by Nighat",
            logo: BL_8,
            description: `Kashmiri Shawls!`,
            images: [],
            socials: [
                {
                    
                }
            ]
        },
        {
            name: "Kyanats Designer Boutique ",
            logo: BL_9,
            description: `Clothes, accessories!`,
            images: [],
            socials: [
                {
                    
                }
            ]
        },

    ];

    return (
        <>
            <Grid container spacing={6} justifyContent="center" alignItems="center" style={{ margin: 18 }}>
                {vendors.map((v, i) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
                        <VendorCard {...v} />
                    </Grid>
                ))}
            </Grid>
        </>
    );
};

export default VendorGrid;

